import { create } from "zustand";
import { subscribeWithSelector } from "zustand/middleware";

export interface FilterState {
  filters: Record<string, any>;
  setFilters: (filters: Record<string, any>) => void;
}

export const useFilterBlogStore = create<FilterState>()(
  subscribeWithSelector((set) => ({
    filters: {},
    setFilters: (filters) => set({ filters }),
  }))
);